module.exports = __webpack_public_path__ + "static/media/word-scramble.0170abe4.png";